<template>
  <div>
    <div>重要訊息</div>
    <div>評分:{{OperationSummary.store_avg_score}}</div>
    <div>本日預約人數:{{OperationSummary.today_reservations}}</div>
    <div>
      <div>重要訊息</div>
      <div class="wrapper" ref="wrapper" :scrollbar="options.scrollbar" :startY="options.startY">
        <my-msg-list
        ref="myMsgList"
          :MsgItems= "loadedMsg"
        >
        </my-msg-list>
      </div>
    </div>
  </div>
</template>

<script>

import MyMsgList from './MyMsgList.vue'
import BScroll from 'better-scroll'

export default {
  name: 'MerchantInfo',
  components: {
    MyMsgList
  },
  data: function () {
    return {
      loadedMsg: [],
      page_number:0,
      items_per_page:20,
      loading:false,
      has_more: true,
      options: {
          pullDownRefresh: {
            threshold: 50, // 当下拉到超过顶部 50px 时，触发 pullingDown 事件
            stop: 20 // 刷新数据的过程中，回弹停留在距离顶部还有 20px 的位置
          },
          pullUpLoad: {
            threshold: 0 // 在上拉到超过底部 20px 时，触发 pullingUp 事件
          },
//          pullDownRefresh: false, //关闭下拉
//          pullUpLoad: false, // 关闭上拉
          click: true,
          probeType: 3,
          startY: 0,
          scrollbar: true,
          mouseWheel: {
            speed: 20,
            invert: false,
            easeTime: 300
            }
        }
    }
  },
  props: [
    ],
  methods: {
    loadMsg: function () {
      if (!this.$bus.session || !this.$bus.session.merchant_store_id) {
        return
      }
      if (this.loading) {
        return
      }
      this.loading = true
      //根據身份決定呼叫的api抓出訊息列表
      this.page_number += 1
      let qryBody = {
        'module':'merchant',
        'method':'getNotifications',
        'page_number':this.page_number,
        'items_per_page':this.items_per_page,
        'query_start_date':'2019-01-01',
        'query_end_date':'2019-12-31',
        'merchant_store_id': this.$bus.session.merchant_store_id
      }
      // let Param = this.$bus.getApiParam('merchant_admin',qryBody)
      // if (Param === null) {
      //  this.$bus.fnShowInfo('請先登入')
      // }
      this.$bus.apiCall(qryBody, function (data, vm) {
        if (data.ok === 0) {
            vm.$bus.fnShowInfo('api讀取失敗：'+data.msg)
            vm.loading = false
            return
          }
          // eslint-disable-next-line
          // append可用concat來寫,記得要assign回自己         
          vm.loadedMsg = vm.loadedMsg.concat(data.data.msg_list)
          // 這個動作是必要的,否則不會refresh
          vm.loadedMsg = vm.CpObj(vm.loadedMsg)
          vm.has_more = data.data.has_more
          // 不要立即刷新否則捲太遠會連續觸發load新分頁append          
          setTimeout(() => {
            if (vm.scroll && data.data.has_more) {
              vm.loading = false
              vm.scroll.finishPullUp()
              vm.scroll.refresh()
            }
          }, 100);
      },this)
    },
    cancel: function () {
      this.CancelCallback();
    },
    load() {
        if (!this.scroll) {
          this.scroll = new BScroll(this.$refs.wrapper, this.options);
          // 上拉
          this.scroll.on('pullingUp', () => {
            // 刷新数据的过程中，回弹停留在距离顶部还有20px的位置
            // 尚未到底時才要抓資料,還沒寫
            if (this.has_more && !this.loading) {
              this.loadMsg();
            }
          })
        } else {
          this.scroll.refresh()
        }
      },
    pullingDownUp() {
        this.scroll.refresh() //重新计算元素高度
      }
  },
  computed: {
    OperationSummary: function () {
      let operation_summary = {"store_avg_score":0,"today_reservations":0}
      if (this.$bus.session && this.$bus.session.operation_summary) {
        operation_summary = this.$bus.session.operation_summary
      }
      return operation_summary
    }
  },
  mounted () {
    // this.loadMsg()
  },
  created() {
    this.$nextTick(() => {
        //this.load()
        this.loadMsg()
      })
  },
  activated() {
    //this.loading = false
    //this.loadedMsg = []
    //this.page_number = 0
    this.loadMsg()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.wrapper {
  height: 480px;
  overflow-y: scroll;
}
</style>
